'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const SwanPopoverContext = createContext({});
const SwanPopoverContextProvider = (e)=>{
    let { children: r, value: t } = e;
    return jsx(SwanPopoverContext.Provider, {
        value: t,
        children: r
    });
};
const useSwanPopover = ()=>useContext(SwanPopoverContext);

export { SwanPopoverContext, SwanPopoverContextProvider, useSwanPopover };
